import { render, staticRenderFns } from "./orderDetal.vue?vue&type=template&id=1497199c&scoped=true"
import script from "./orderDetal.vue?vue&type=script&lang=js"
export * from "./orderDetal.vue?vue&type=script&lang=js"
import style0 from "./orderDetal.vue?vue&type=style&index=0&id=1497199c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1497199c",
  null
  
)

export default component.exports